import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class AtendimentoApiClient {


    async buscarAtendimentosPaginado(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/atendimento',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async buscarAtendimentoPorId(input) {
        return await axios.get(`/atendimento/buscarPorId/${input.atendimentoId}`)
    }

    async agendarAtendimento(input) {
        return await axios.post('/atendimento/agendar', input)
    }

    async iniciarAtendimento(input) {
        return await axios.post('/atendimento/iniciar', input)
    }

    async cancelarAtendimento(input) {
        return await axios.put('/atendimento/cancelar', input)
    }

    async finalizarAtendimento(input) {
        return await axios.put('/atendimento/finalizar', input)
    }

    async atualizarAtendimento(input) {
        return await axios.put('/atendimento/atualizar', input)
    }

    async removerAtendimento(input) {
        await axios.delete(`/atendimento/deletar/${input.id}`)
    }

    async inserirProcedimento(input) {
        return await axios.post('/atendimento/dente/inserirProcedimento', input)
    }

    async atualizarProcedimento(input) {
        return await axios.put('/atendimento/dente/atualizarProcedimento', input)
    }

    async removerProcedimento(input) {
        await axios.delete(`/atendimento/dente/deletarProcedimento/${input.atendimentoId}/${input.id}`)
    }


    async buscarHistoricoProcedimento(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/atendimento/dente/buscarHistorico',
            filtros,
            paginacao
        )
        return axios.get(url)
    }
}

export default new AtendimentoApiClient()
